/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable @typescript-eslint/no-unused-vars, no-restricted-syntax */
import { DocumentNode } from 'graphql';
import * as Types from '../../../types/definitions/vendor/graphql-schema.d';

export type ShopOutfitFragmentFragment = {
  __typename?: 'Outfit';
  id: string;
  items: {
    __typename?: 'OutfitItem';
    sticker?: {
      __typename?: 'ModeStickerLabel';
      label: string;
      theme: Types.ModeStickerLabelTheme;
    } | null;
    laydown: {
      __typename?: 'OutfitItemLaydown';
      maxHeight: number;
      maxWidth: number;
      x: number;
      y: number;
      xAnchor: string;
      yAnchor: string;
    };
    shopProductVariant?: {
      __typename?: 'ShopProductVariant';
      id: string;
      sku: string;
      url: string;
      inventory: {
        __typename?: 'ShopInventory';
        availability: Types.InventoryAvailability;
        quantityAvailable: number;
      };
      image?: {
        __typename?: 'ShopMedia';
        altText: string;
        baseUrl: string;
        mediaPath: string;
        medium: string;
        small: string;
      } | null;
    } | null;
  }[];
};

export const ShopOutfitFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopOutfitFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Outfit' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sticker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'laydown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxHeight' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxWidth' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'xAnchor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'yAnchor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shopProductVariant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inventory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'availability' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'quantityAvailable',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'altText' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'baseUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mediaPath' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'medium' },
                              name: { kind: 'Name', value: 'transformedSrc' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'options' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'sizePreset',
                                        },
                                        value: {
                                          kind: 'EnumValue',
                                          value: 'MEDIUM',
                                        },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'transformations',
                                        },
                                        value: {
                                          kind: 'ListValue',
                                          values: [
                                            {
                                              kind: 'EnumValue',
                                              value: 'TRIM_EFFECT',
                                            },
                                            {
                                              kind: 'EnumValue',
                                              value: 'AUTO_FORMAT_QUALITY',
                                            },
                                            {
                                              kind: 'EnumValue',
                                              value: 'REPLACE_COLOR_FOR_SHOP',
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'small' },
                              name: { kind: 'Name', value: 'transformedSrc' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'options' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'sizePreset',
                                        },
                                        value: {
                                          kind: 'EnumValue',
                                          value: 'SMALL',
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
